export default __webpack_public_path__ + "static/media/1.f5b27712.svg";